import { axiosManager } from '../config';
import { Corporation, CorporationRemainingTimesDto } from '../model';

export const CorporationService = {
  path: '/corporations',

  getById(id: number): Promise<Corporation> {
    const url = `${this.path}/${id}`;

    return axiosManager
      .getInstance()
      .get(url)
      .then((res) => res.data);
  },

  getQuota(id: number, date: string): Promise<CorporationRemainingTimesDto> {
    const url = `${this.path}/${id}/quota`;

    return axiosManager
      .getInstance()
      .get(url, { params: { date } })
      .then((res) => res.data);
  },
};
